import loadable from '@loadable/component';

export const ReportModal = loadable(
  () => import(/* webpackChunkName: "extra" */ './report-modal')
);
